export const getIsTimerRunning = (state, patientId) =>
  !!state.timeTracker[patientId]?.isTimerRunning;
export const getTimer = (state, patientId) => state.timeTracker[patientId]?.timer || 0;
